export default __webpack_public_path__ + "static/544-2193a5bf41a102cbbd29534e88eb6ab7.gif";